import useSelectBrand from "#hooks/styles/useSelectBrand";

const TabButton = ({ label, isActive, onClick }) => {
  const { color } = useSelectBrand();
  return (
    <button
      className={`flex-1 h-12 rounded-2xl ${isActive ? `bg-${color} border-none` : "bg-slate-50 border border-neutral-200"}`}
      onClick={onClick}
      type="button"
    >
      {label}
    </button>
  );
};

export default TabButton;
